module.exports = __webpack_public_path__ + "img/logo_esq.7056fa59.png";